import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { map, get } from 'lodash';
import CollapsingTaxAndFees from './collapsing-tax-and-fees';
import ModalManager from '../elements-modal/modal-manager-v2';
import { ItemDetailsModal } from './modals/item-details-modal';
import { connect } from 'react-redux';

const AddOnsReviewTableRows = ({
  itemsArray,
  currency,
  ssoId,
  addOnsTotal,
  addOnsTaxTotal,
  addOnsFeeTotal,
  whichModal,
  toggleModal,
  guestView,
  taxesArray,
  feesArray,
  iosWebView,
  hostAddOnsSummary,
  masterContract,
  profile
}) => {
  const masterCalculations = masterContract?.calculations;
  const guestCalculations = masterCalculations?.guest;

  const isHost = masterContract?.host_sso_id === profile?.SSOid;

  return (
    <div className="add-ons-review-table-rows">
      <div>
        { map(itemsArray, (item, i) => {
          const label = get(item, 'meta.label', '');
          const itemId = get(item, 'meta.item_id', '');
          const customPrice = get(item, 'custom_price');
          const price = 0 <= customPrice ? customPrice : get(item, 'meta.unit_cost');
          const inventoryItemObject = get(item, 'meta.unit_cost_basis', '');
          const unitCostBasis = inventoryItemObject ? inventoryItemObject.replace('_', ' ') : null;
          const toggleItemDescriptionModal = () => {
            toggleModal(`itemDescriptionModal-${itemId}`);
          };

          if (guestView || !get(item, 'meta.is_concierge')) {
            return <div key={`addOnLineItem-${i}`}>
              <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
                <ItemDetailsModal
                  id={`itemDescriptionModal-${itemId}`}
                  toggleModal={toggleModal}
                  item={item.meta}
                  whichModal={whichModal}
                  iosWebView={iosWebView}
                  currency={currency}
                />
              </ModalManager>
              <div className="add-on-row flex space-between table-row">
                <div className="title-field flex">
                  <span className="margin-sm-right">{label}</span>
                  <div className="d-sm-none">
                    <span>{`(x${item.units})`}</span>
                    { guestView &&
                      <span className="margin-sm-left info-icon" onClick={toggleItemDescriptionModal}>
                        <img src="/web-2/assets/images/info-icon.svg?v=rb" alt="info-icon" />
                      </span>
                    }
                  </div>
                  { guestView &&
                    <span className="margin-sm-left info-icon d-xs-none d-sm-block" onClick={toggleItemDescriptionModal}>
                      <img src="/web-2/assets/images/info-icon.svg?v=rb" alt="info-icon" />
                    </span>
                  }
                </div>
                <div className="quantity-field d-xs-none d-sm-block">{item.units}</div>
                <div className="price-field d-xs-none d-sm-block" data-testing-id="price">
                  <FormattedNumber value={price} currency={currency} style={'currency'} /> {unitCostBasis}
                </div>
                <div className="amount-field" data-testing-id={`amount-${i}`}>
                  <FormattedNumber value={item.primary_amount[ssoId] || 0} currency={currency} style={'currency'} />
                </div>
              </div>
              <hr className="dotted margin-md-top margin-md-bottom" />
            </div>
          }
          return null;
        })}
        <CollapsingTaxAndFees
          addOnsTaxTotal={addOnsTaxTotal}
          addOnsFeeTotal={addOnsFeeTotal}
          taxesArray={taxesArray}
          feesArray={feesArray}
          currency={currency}
        />

      {!isHost && guestCalculations?.us_sales_tax_add_ons > 0 && (
        <div className="add-on-row flex space-between table-row margin-md-top">
          <div className="title-field flex">
            <FormattedMessage
              id='price-breakdown.add-on-sales-tax'
              defaultMessage='Add-on sales tax'
            />
          </div>
          <div
            className="amount-field"
            data-testing-id='add-on-sales-tax-amount'
          >
            <FormattedNumber
              value={guestCalculations.us_sales_tax_add_ons}
              currency={currency}
              style='currency'
            />
          </div>
        </div>
      )}

      <hr className="dotted margin-md-top margin-md-bottom" />
        <div className="flex space-between heavy table-row">
          <div>
            <FormattedMessage
              id='inbox.add_ons_review_table_rows.addons_total'
              defaultMessage='Add-ons total'
            />
          </div>


          <div>
            {isHost || masterCalculations?.add_ons_guest_with_tax === undefined ? (
              <FormattedNumber
                value={guestView ? addOnsTotal : get(hostAddOnsSummary, 'amount') || addOnsTotal}
                currency={currency}
                style={'currency'} 
              />
            ) : (
              <FormattedNumber
                value={masterCalculations?.add_ons_guest_with_tax || 0}
                currency={currency}
                style={'currency'}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

AddOnsReviewTableRows.propTypes = {
  itemsArray: PropTypes.array,
  currency: PropTypes.string,
  ssoId: PropTypes.string,
  addOnsTaxTotal: PropTypes.string,
  addOnsFeeTotal: PropTypes.string,
  whichModal: PropTypes.string,
  toggleModal: PropTypes.func,
  iosWebView: PropTypes.bool,
  taxesArray: PropTypes.array,
  feesArray: PropTypes.array,
  guestView: PropTypes.bool
};

const mapStateToProps = ({ profile }) => ({
  profile
});
export default connect(mapStateToProps)(AddOnsReviewTableRows);
